import { Outlet } from 'react-router';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { FixtureTabLayout } from '#src/layouts/FixtureLayout/FixtureTabLayout/index.tsx';

const CareerBoardLayout = () => {
  const { sport } = useSportContext();
  const {
    flags: {
      enableSorare27Nav = { BASEBALL: false, FOOTBALL: false, NBA: false },
    },
  } = useFeatureFlags();

  if (enableSorare27Nav[sport]) {
    return <Outlet />;
  }

  return (
    <FixtureTabLayout
      eventType={So5FixtureEvent.CLASSIC}
      so5FixtureSlug="ongoing"
    >
      <Outlet />
    </FixtureTabLayout>
  );
};

export default CareerBoardLayout;
